import React, { useState } from "react";
import cn from "classnames";
import Footer from "components/Footer/Footer";
import { Link } from "react-router-dom";
import styles from "./signin.module.scss";
import dash_styles from "../mychargers.module.scss";
import form_styles from "./newPassword.module.scss";
import { Auth } from "aws-amplify";
import styles2 from "./newPassword.module.scss";

export default function NewPassword(props) {
  const [userData, setUserData] = useState({
    passwordOne: "",
    passwordTwo: "",
    code: "",
  });
  const [errorMessage, setErrorMessage] = useState({ value: "" });
  const userName = localStorage.getItem("name");
  async function newPass(userData) {
    if (userData.passwordOne === userData.passwordTwo) {
      if (userData.code === "") {
        setErrorMessage((prevState) => ({
          value: "Please enter the OTP",
        }));
      } else {
        try {
          if (
            userData.passwordOne === "" ||
            userData.passwordTwo === "" ||
            userData.code === ""
          ) {
            setErrorMessage((prevState) => ({
              value: "Enter Password",
            }));
          } else {
            const isNewPassword = await Auth.forgotPasswordSubmit(
              userName,
              userData.code,
              userData.passwordOne
            )
              .then((data) => {
                localStorage.setItem("isSetPassword", true);
                window.location.pathname = "/passwordSuccess";
              })
              .catch((err) =>
                setErrorMessage((prevState) => ({ value: "Incorrect OTP" }))
              );
          }
        } catch (error) {
          console.log("error signing in", error);
          //If credentials entered is invalid
          setErrorMessage((prevState) => ({
            value: "Invalid username/password",
          }));
        }
      }
    } else {
      setErrorMessage((prevState) => ({
        value: "Password mismatch",
      }));
    }
  }

  const handleInputChange = (e) => {
    setUserData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    newPass(userData);
    //if password field is empty, return error message
  };

  return (
    <div className={`ldpg ${cn(dash_styles.main, dash_styles.main_layout)}`}>
      <div className={cn(dash_styles.main_flex, form_styles.main_flex)}>
        <img
          src={require("assets/logo.png").default}
          alt="Rectangle 1"
          className={cn(styles.logo_boxl1, styles.logo_boxl_layout_newPass)}
        />

        <form onSubmit={handleSubmit}>
          <div className={cn(styles.panel_group, styles.panel_group_layout1)}>
            {errorMessage.value !== "" && (
              <p className={cn(styles.error)}> {errorMessage.value} </p>
            )}

            <div className={cn(styles.username, styles.username_layout)}>
              <h1
                className={cn(
                  styles.password_field_title,
                  styles.password_field_title_layout
                )}
              >
                {"Enter OTP (sent to your email address)"}
              </h1>
              <input
                type="text"
                id="number"
                name="code"
                onChange={(e) => handleInputChange(e)}
                className={cn(styles.password_box, styles.password_box_layout2)}
              />
            </div>

            <div
              className={cn(
                styles.password_block,
                styles.password_block_layout2
              )}
            >
              <h1
                className={cn(
                  styles.password_title2,
                  styles.password_title_layout
                )}
              >
                {"Create New Password"}
              </h1>
              <input
                type="password"
                name="passwordOne"
                autocomplete="new-password"
                onChange={(e) => handleInputChange(e)}
                id="password"
                minLength="8"
                className={cn(styles.password_box, styles.password_box_layout2)}
              />
            </div>

            <div
              className={cn(
                styles.password_block,
                styles.password_block_layout2
              )}
            >
              <h1
                className={cn(
                  styles.password_title2,
                  styles.password_title_layout
                )}
              >
                {"Confirm New Password"}
              </h1>
              <input
                type="password"
                name="passwordTwo"
                onChange={(e) => handleInputChange(e)}
                id="password"
                minLength="8"
                className={cn(styles.password_box, styles.password_box_layout2)}
              />
            </div>

            <h3
              className={cn(
                styles.return_login_text,
                styles.return_login_text_layout
              )}
            >
              <Link to="/signin" className={cn(styles.return_login_text2)}>
                Back to login
              </Link>
            </h3>

            <button
              type="submit"
              className={cn(
                styles.panel_group_big_title2,
                styles.panel_group_big_title_layout2,
                styles.panel_group_block,
                styles.panel_group_block_layout
              )}
            >
              {"Submit"}
            </button>
            {/* disabled={!userData.passwordOne || !userData.passwordTwo || !userData.code}  */}
          </div>
          {/* <div className={cn(styles.panel_group, styles.panel_group_layout)}>
            <h3 className={cn(styles.credentials_info)}>
              Password must meet the following criteria
            </h3>
            <h3 className={cn(styles.credentials_info2)}>
              <img src={require('assets/Close.svg').default} alt='close logo' className={cn(styles.credentials_img_2)}/>
              Password must be of minimum 8 characters of length
            </h3>
            <h3 className={cn(styles.credentials_info3)}>
            <img src={require('assets/done.svg').default} alt='close logo' className={cn(styles.credentials_img_3)}/>
              Password must contain an alphabet in caps [A-Z]
            </h3>
            <h3 className={cn(styles.credentials_info2)}>
            <img src={require('assets/Close.svg').default} alt='close logo' className={cn(styles.credentials_img_2)}/>
              Password must contain an alphabet in small [a-z]
            </h3>
            <h3 className={cn(styles.credentials_info2)}>
            <img src={require('assets/Close.svg').default} alt='close logo' className={cn(styles.credentials_img_2)}/>
              Password must contain a numeric number [0-9]
            </h3>
            <h3 className={cn(styles.credentials_info2)}>
            <img src={require('assets/Close.svg').default} alt='close logo' className={cn(styles.credentials_img_2)}/>
              Password must contain a special character [#,@,%,!]
            </h3>
          </div> */}
        </form>

        <Footer></Footer>
      </div>
    </div>
  );
}

NewPassword.inStorybook = true;
